<template>
  <div class="content">
    <!-- Stats V2 -->
    <v-card v-if="stats" elevation="0" outlined>
      <v-card-text>
        <div class="row">
          <div class="col">
            BDC V2 :
            <span style="color: black; font-weight: bold">{{
              stats.bdcTotal
            }}</span>
            <br />
            Signés aujourd'hui :
            <span style="color: black; font-weight: bold">{{
              stats.bdcToday
            }}</span>
            <br />
            V2 : <strong>{{ stats.nbV2 }}</strong> / V1V2 :
            <strong>{{ stats.nbV1V2 }}</strong>
          </div>
          <div class="col">
            Soumis ASP :
            <span style="color: black; font-weight: bold">{{
              stats.bdcSoumisAsp
            }}</span>
            <br />
            Rejetés :
            <span style="color: red; font-weight: bold">{{
              stats.bdcRejetes
            }}</span>
            <br />
            VA générées :
            <span style="color: black; font-weight: bold">{{
              stats.bdcVa
            }}</span>
          </div>
          <div class="col">
            PS actives :
            <span style="color: black; font-weight: bold">{{
              stats.psMonitoring
            }}</span>
            <br />
            PS prêtes :
            <span style="color: black; font-weight: bold">{{
              stats.psReady
            }}</span>
            <br />
            PS soumises :
            <span style="color: black; font-weight: bold">{{
              stats.psSubmitted
            }}</span>
          </div>
        </div>

        <v-divider style="margin: 10px 0"></v-divider>
        <div class="row">
          <div class="col">
            <div style="font-size: 12px; color: #666; margin-bottom: 4px">
              TOTAL PRESTATION
            </div>
            <strong>{{ stats.totalPPHT }} € HT</strong>
            <span style="color: green; font-weight: bold; margin-left: 8px"
              >{{ stats.totalPPTTC }} € TTC</span
            >
          </div>
          <div class="col">
            <div style="font-size: 12px; color: #666; margin-bottom: 4px">
              AVANCE (40%)
            </div>
            <strong>{{ stats.avanceHT }} € HT</strong>
            <span style="color: green; margin-left: 8px"
              >{{ stats.avanceTTC }} € TTC</span
            >
          </div>
          <div class="col">
            <div style="font-size: 12px; color: #666; margin-bottom: 4px">
              SOLDE (60%)
            </div>
            <strong>{{ stats.soldeHT }} € HT</strong>
            <span style="color: green; margin-left: 8px"
              >{{ stats.soldeTTC }} € TTC</span
            >
          </div>
          <div class="col" v-if="stats.psEstimeHT > 0">
            <div style="font-size: 12px; color: #666; margin-bottom: 4px">
              PREST. SECONDAIRE
            </div>
            <strong>{{ stats.psEstimeHT }} € HT</strong>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Recherche -->
    <md-card style="margin-bottom: 40px; margin-top: 10px">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-field>
            <label>Recherche multi-critères</label>
            <md-input v-on:keyup.enter="search" v-model="query"></md-input>
            <span class="md-helper-text"
              >Nom, RPPS, FINESS, raison sociale, email, téléphone, N° éditeur,
              N° ASP</span
            >
          </md-field>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select
            :items="sortOptions"
            v-model="sortBy"
            label="Trier par"
          ></v-select>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select
            :items="['Décroissant', 'Croissant']"
            v-model="sortOrder"
            label="Tri"
          ></v-select>
        </div>
        <div
          class="md-layout-item"
          style="margin-top: 7px"
          v-if="currentTab !== 'ps'"
        >
          <v-select
            :items="emailStatusFilterOptions"
            v-model="emailStatusFilter"
            label="Statut email"
            @change="search()"
          ></v-select>
        </div>
        <div
          class="md-layout-item"
          style="margin-top: 7px"
          v-if="currentTab !== 'ps'"
        >
          <v-select
            :items="partyTypeOptions"
            v-model="partyType"
            item-text="text"
            item-value="value"
            label="Type structure"
            @change="search()"
          ></v-select>
        </div>
      </div>
      <div
        v-if="searchTruncated"
        style="font-size: 12px; color: #c62828; margin-top: 4px"
      >
        Plus de 200 résultats sur la recherche - affinez votre saisie pour ne
        rien manquer.
      </div>
      <md-button class="md-prokov researcheButton" @click="search()"
        >Rechercher</md-button
      >
      <button class="diagCloseButton" @click="clearSearch()">
        <md-icon>delete</md-icon>
      </button>
    </md-card>

    <!-- Filtres -->
    <v-tabs
      v-model="currentTab"
      background-color="prokov"
      dark
      slider-color="white"
      slider-size="3"
      style="border-radius: 8px; margin-top: 10px"
    >
      <v-tab v-for="t in tabDefs" :key="t.key" :href="'#' + t.key">
        {{ t.label }}
        <span
          v-if="tabCounts[t.key]"
          style="
            background: rgba(255, 255, 255, 0.25);
            color: #fff;
            font-size: 10px;
            padding: 1px 6px;
            border-radius: 10px;
            margin-left: 6px;
          "
        >
          {{ tabCounts[t.key] }}
        </span>
      </v-tab>
    </v-tabs>

    <!-- Tableau BDC (tous les onglets sauf PS) -->
    <v-tabs-items v-model="currentTab" style="background: rgba(0, 0, 0, 0)">
      <v-tab-item
        v-for="t in tabDefs.filter((t) => t.key !== 'ps')"
        :key="t.key"
        :value="t.key"
      >
        <!-- En-tête corbeille : compteur + bouton Vider -->
        <div
          v-if="t.key === 'deleted'"
          style="
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 8px;
            background: #fff3e0;
            border-radius: 4px;
            margin: 8px 0;
          "
        >
          <v-icon color="orange darken-2">mdi-trash-can-outline</v-icon>
          <span style="font-size: 13px; flex: 1">
            <strong>{{ tabCounts.deleted || 0 }}</strong> BDC en corbeille
            <span v-if="tabCounts.deleted" style="color: #888">
              (purge automatique après {{ trashTtlDays }} jours via cron 3h00)
            </span>
          </span>
          <v-btn
            color="red"
            small
            dark
            :disabled="!tabCounts.deleted"
            @click="openEmptyTrashDialog"
          >
            <v-icon x-small left>mdi-delete-empty-outline</v-icon>
            Vider la corbeille
          </v-btn>
        </div>
        <div style="width: 100%" class="md-layout">
          <md-table v-if="rows && rows.length" v-model="rows">
            <md-table-row
              slot="md-table-row"
              md-selectable="single"
              slot-scope="{ item }"
            >
              <md-table-cell md-label="Résident" v-if="item.resident">
                {{ item.resident.prénom }} {{ item.resident.nom }}
              </md-table-cell>

              <md-table-cell md-label="RPPS">
                <template v-if="item.msp">
                  <span :title="mspTooltip(item.msp)"
                    >F - {{ item.msp.FINESS }}</span
                  >
                  <div
                    v-if="item.msp.raisonSociale"
                    style="font-size: 11px; color: #666"
                  >
                    {{ item.msp.raisonSociale }}
                  </div>
                </template>
                <template v-else-if="item.resident"
                  >R - {{ item.resident.RPPS }}</template
                >
              </md-table-cell>

              <md-table-cell md-label="N° Éditeur">{{
                item.numeroEditeur
              }}</md-table-cell>

              <md-table-cell md-label="Type">
                <v-chip
                  v-if="item.typePrestation"
                  x-small
                  :color="typeColor(item.typePrestation)"
                  dark
                >
                  {{ item.typePrestation }}
                </v-chip>
                <span v-else-if="item.wave === 'V1'" style="font-size: 12px"
                  >V1</span
                >
                <span v-else>-</span>
              </md-table-cell>

              <md-table-cell md-label="Montant"
                >{{ item.montantSegurHT }} €</md-table-cell
              >

              <md-table-cell md-label="Date signature">
                {{ getDate(item.dateSignatureCommande || item.createdAt) }}
              </md-table-cell>

              <md-table-cell md-label="État">
                <v-chip x-small :color="stateColor(item.state)" dark>{{
                  stateLabel(item.state)
                }}</v-chip>
              </md-table-cell>

              <md-table-cell
                md-label="Pilote"
                v-if="currentTab !== 'archivesV1'"
              >
                <v-chip
                  v-if="item.isPilot"
                  x-small
                  :color="pilotColor(item.pilotStatus)"
                  dark
                >
                  {{ pilotLabel(item.pilotStatus) }}
                </v-chip>
                <span v-else style="color: #ccc">-</span>
              </md-table-cell>

              <md-table-cell
                md-label="Email"
                v-if="currentTab !== 'archivesV1'"
              >
                <v-tooltip
                  bottom
                  :disabled="item.emailStatus !== 'FAILED' || !item.emailError"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      x-small
                      :color="emailStatusColor(item.emailStatus)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ emailStatusLabel(item.emailStatus) }}
                    </v-chip>
                  </template>
                  <span>{{ item.emailError }}</span>
                </v-tooltip>
              </md-table-cell>

              <md-table-cell md-label="N° ASP">{{
                item.numeroASP || "-"
              }}</md-table-cell>

              <md-table-cell md-label="VA">
                <v-chip
                  v-if="item.files && item.files.vaPDF"
                  color="green"
                  x-small
                  dark
                  >Oui</v-chip
                >
                <v-chip v-else color="red" x-small dark>Non</v-chip>
              </md-table-cell>

              <md-table-cell md-label="PS" v-if="currentTab !== 'archivesV1'">
                <v-chip
                  v-if="item.ps"
                  x-small
                  :color="psColor(item.ps.status)"
                  dark
                >
                  {{ item.ps.status }}
                </v-chip>
                <span v-else>-</span>
              </md-table-cell>

              <template v-if="currentTab === 'mustResign'">
                <md-table-cell md-label="Marqué le">
                  {{ item.resignMarkedAt ? getDate(item.resignMarkedAt) : "-" }}
                </md-table-cell>
                <md-table-cell md-label="Marqué par">
                  {{ item.resignMarkedBy || "-" }}
                </md-table-cell>
              </template>

              <template v-if="currentTab === 'rejetes'">
                <md-table-cell md-label="Code">{{
                  item.codeTraitement
                }}</md-table-cell>
                <md-table-cell md-label="Libellé">{{
                  item.libelleTraitement
                }}</md-table-cell>
              </template>

              <template v-if="currentTab === 'deleted'">
                <md-table-cell md-label="Supprimé le">
                  {{ getDate(item.deletedAt) }}
                </md-table-cell>
                <md-table-cell md-label="Purge">
                  <v-chip
                    x-small
                    :color="purgeColor(item.purgeScheduledAt)"
                    dark
                  >
                    {{ purgeLabel(item.purgeScheduledAt) }}
                  </v-chip>
                </md-table-cell>
              </template>

              <md-table-cell md-label="">
                <v-btn
                  class="mx-2"
                  icon
                  small
                  color="teal"
                  @click="openDetail(item)"
                >
                  <v-icon dark>mdi-format-list-bulleted-square</v-icon>
                </v-btn>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div v-else style="padding: 20px; text-align: center; color: #999">
            Aucun bon de commande
          </div>
        </div>

        <div class="text-center" style="margin-top: 10px">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-tab-item>

      <!-- Onglet Prestation Secondaire (tableau dédié) -->
      <v-tab-item key="ps" value="ps">
        <div
          style="
            display: flex;
            gap: 24px;
            align-items: center;
            flex-wrap: wrap;
            padding: 8px 4px;
            font-size: 11px;
            color: #888;
          "
        >
          <span
            >PERF :
            <span style="color: green">● ≥60% = 1.0</span>
            <span style="color: orange; margin-left: 6px">● 40-59% = 0.5</span>
            <span style="color: red; margin-left: 6px">● &lt;40% = 0</span>
          </span>
          <span style="border-left: 1px solid #ddd; padding-left: 12px">
            <strong>Dt</strong> docs attendus
            <strong style="margin-left: 8px">Dm</strong> docs envoyés
            <strong style="margin-left: 8px">T</strong> patients
            <strong style="margin-left: 8px">Tq</strong> INS qualifiée
            <strong style="margin-left: 8px">Ts</strong> INS transitoire
          </span>
        </div>
        <div style="width: 100%" class="md-layout">
          <md-table v-if="psRows && psRows.length" v-model="psRows">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Résident" v-if="item.resident">
                {{ item.resident.prénom }} {{ item.resident.nom }}
              </md-table-cell>

              <md-table-cell md-label="RPPS" v-if="item.resident">
                {{ item.resident.RPPS }}
              </md-table-cell>

              <md-table-cell md-label="N° Éditeur">{{
                item.numeroEditeur
              }}</md-table-cell>

              <md-table-cell md-label="Début">{{
                item.dateDebut
              }}</md-table-cell>
              <md-table-cell md-label="Fin">{{ item.dateFin }}</md-table-cell>

              <md-table-cell md-label="Status">
                <v-chip x-small :color="psColor(item.status)" dark>{{
                  item.status
                }}</v-chip>
              </md-table-cell>

              <md-table-cell md-label="PERF">
                <strong
                  v-if="item.perfCoefficient != null"
                  :style="{
                    color:
                      item.perfCoefficient >= 1
                        ? 'green'
                        : item.perfCoefficient > 0
                        ? 'orange'
                        : 'red',
                  }"
                >
                  {{ item.perfCoefficient }}
                </strong>
                <strong
                  v-else
                  :style="{
                    color:
                      item.dmDtRatio >= 60
                        ? 'green'
                        : item.dmDtRatio >= 40
                        ? 'orange'
                        : 'red',
                  }"
                >
                  {{
                    item.dmDtRatio >= 60
                      ? "1.0"
                      : item.dmDtRatio >= 40
                      ? "0.5"
                      : "0"
                  }}
                </strong>
              </md-table-cell>

              <md-table-cell md-label="Progression" style="min-width: 140px">
                <div style="display: flex; align-items: center; gap: 8px">
                  <v-progress-linear
                    :value="item.dmDtRatio"
                    :color="
                      item.dmDtRatio >= 60
                        ? 'green'
                        : item.dmDtRatio >= 40
                        ? 'orange'
                        : 'red'
                    "
                    height="12"
                    rounded
                    style="max-width: 80px"
                  ></v-progress-linear>
                  <span style="font-size: 12px; font-weight: bold"
                    >{{ item.dmDtRatio }}%</span
                  >
                </div>
              </md-table-cell>

              <md-table-cell md-label="Dt">{{ item.dt }}</md-table-cell>
              <md-table-cell md-label="Dm">{{ item.dm }}</md-table-cell>
              <md-table-cell md-label="T">{{ item.t }}</md-table-cell>
              <md-table-cell md-label="Tq">{{ item.tq }}</md-table-cell>
              <md-table-cell md-label="Ts">{{ item.ts }}</md-table-cell>
            </md-table-row>
          </md-table>
          <div v-else style="padding: 20px; text-align: center; color: #999">
            Aucune prestation secondaire
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <!-- Détail dialog -->
    <v-dialog v-model="dialog" width="900" @input="onDialogToggle">
      <v-card v-if="selectedItem">
        <v-card-title class="text-h5 grey lighten-2">
          {{
            selectedItem.resident
              ? selectedItem.resident.prénom + " " + selectedItem.resident.nom
              : "BDC"
          }}
          <v-spacer></v-spacer>
          <!-- En attente / Re-signé / Nominal selon mustResign + resignMarkedAt -->
          <v-chip
            v-if="selectedItem.mustResign"
            small
            color="orange darken-2"
            dark
            class="ml-2"
            title="En attente de signature du médecin"
          >
            <v-icon left small>mdi-clock-alert-outline</v-icon>
            En attente de re-signature
          </v-chip>
          <v-chip
            v-else-if="selectedItem.resignMarkedAt"
            small
            color="green darken-1"
            dark
            class="ml-2"
            title="BDC re-signé par le médecin après correction admin"
          >
            <v-icon left small>mdi-check-decagram</v-icon>
            Re-signé après correction
          </v-chip>
        </v-card-title>
        <v-card-text v-if="editMode">
          <!-- Mode edition : EditableBdcCard -->
          <editable-bdc-card
            :bdc="selectedItem"
            @save="onEditableSave"
            @cancel="cancelEditMode"
          />
        </v-card-text>
        <v-card-text v-else>
          <v-col cols="12">
            <h4>BON DE COMMANDE</h4>
            <div style="color: blue; margin-left: 10px; margin-top: 10px">
              ID : {{ selectedItem.id }}<br />
              N° éditeur : {{ selectedItem.numeroEditeur }} / N° ASP :
              {{ selectedItem.numeroASP || "-" }}<br />
              Montant HT : {{ selectedItem.montantSegurHT }} € / Type :
              {{ selectedItem.typePrestation }}<br />
              État : {{ selectedItem.state }} / Wave : {{ selectedItem.wave
              }}<br />
              Partenaire : {{ selectedItem.partnerCode }}<br />
              <span v-if="selectedItem.isPilot">
                Pilote :
                <v-chip
                  x-small
                  :color="pilotColor(selectedItem.pilotStatus)"
                  dark
                  >{{ pilotLabel(selectedItem.pilotStatus) }}</v-chip
                ><br />
              </span>
              Email BDC :
              <v-tooltip bottom :disabled="!selectedItem.emailError">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    :color="emailStatusColor(selectedItem.emailStatus)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ emailStatusLabel(selectedItem.emailStatus) }}
                  </v-chip>
                </template>
                <span>{{ selectedItem.emailError }}</span>
              </v-tooltip>
              <br />
              <span v-if="selectedItem.resignMarkedAt">
                Re-signature :
                <v-chip
                  v-if="selectedItem.mustResign"
                  x-small
                  color="orange darken-2"
                  dark
                  >En attente médecin</v-chip
                >
                <v-chip v-else x-small color="green darken-1" dark
                  >Re-signé</v-chip
                >
                - marqué le
                <strong>{{ getDate(selectedItem.resignMarkedAt) }}</strong>
                <span v-if="selectedItem.resignMarkedBy">
                  par <strong>{{ selectedItem.resignMarkedBy }}</strong>
                </span>
                <span
                  v-if="selectedItem.resignReason"
                  style="color: #555; font-style: italic"
                >
                  - motif : {{ selectedItem.resignReason }}
                </span>
                <br />
              </span>
              <br />
              <div
                style="display: flex; gap: 8px; flex-wrap: wrap; margin: 4px 0"
              >
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.orderFormPDF"
                  x-small
                  color="primary"
                  @click="downloadPdf('bdc', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> BDC
                </v-btn>
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.vaPDF"
                  x-small
                  color="green"
                  dark
                  @click="downloadPdf('va', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> VA
                </v-btn>
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.invoicePDF"
                  x-small
                  color="orange"
                  dark
                  @click="downloadPdf('fac', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> Facture
                </v-btn>
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.momPDF"
                  x-small
                  color="grey"
                  dark
                  @click="downloadPdf('mom', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> MOM
                </v-btn>
                <span
                  v-if="
                    !(
                      selectedItem.files &&
                      (selectedItem.files.orderFormPDF ||
                        selectedItem.files.vaPDF ||
                        selectedItem.files.invoicePDF ||
                        selectedItem.files.momPDF)
                    )
                  "
                  style="color: #999"
                >
                  Aucun PDF disponible
                </span>
              </div>
              <br />
              <span v-if="selectedItem.codeTraitement" style="color: green">
                Retour ASP : {{ selectedItem.codeTraitement }} /
                {{ selectedItem.libelleTraitement }}<br />
              </span>
            </div>

            <div v-if="selectedItem.resident" style="margin-top: 20px">
              <h4>RÉSIDENT</h4>
              <div style="color: blue; margin-left: 10px; margin-top: 10px">
                {{ selectedItem.resident.nom }} {{ selectedItem.resident.prénom
                }}<br />
                RPPS : {{ selectedItem.resident.RPPS }}<br />
                Email : {{ selectedItem.resident.email }}<br />
                Tél : {{ selectedItem.resident.phone }}<br />
              </div>
            </div>

            <div v-if="selectedItem.msp" style="margin-top: 20px">
              <h4>MSP</h4>
              <div style="color: blue; margin-left: 10px; margin-top: 10px">
                FINESS : {{ selectedItem.msp.FINESS }}<br />
              </div>
            </div>

            <div v-if="selectedItem.ps" style="margin-top: 20px">
              <h4>PRESTATION SECONDAIRE</h4>
              <div style="color: blue; margin-left: 10px; margin-top: 10px">
                Status : {{ selectedItem.ps.status }}<br />
                PERF :
                {{
                  selectedItem.ps.perfCoefficient != null
                    ? selectedItem.ps.perfCoefficient
                    : "-"
                }}<br />
                Période : {{ selectedItem.ps.dateDebut }} au
                {{ selectedItem.ps.dateFin }}<br />
                Dt : {{ selectedItem.ps.dt }} / Dm : {{ selectedItem.ps.dm
                }}<br />
              </div>
            </div>
          </v-col>
        </v-card-text>
        <v-divider v-if="!editMode"></v-divider>
        <v-card-actions v-if="editMode">
          <v-spacer></v-spacer>
          <span style="font-size: 12px; color: #666; margin-right: 12px">
            Édition en cours - utilisez les boutons du formulaire pour
            enregistrer ou annuler
          </span>
        </v-card-actions>
        <v-card-actions v-else>
          <!-- BDC en corbeille : seul Restaurer est dispo (les autres actions sont contextuelles) -->
          <v-btn
            v-if="
              selectedItem &&
              selectedItem.deletedAt &&
              selectedItem.wave !== 'V1'
            "
            x-small
            color="green"
            dark
            @click="restoreBDC(selectedItem)"
          >
            <v-icon x-small left>mdi-restore</v-icon>
            Restaurer
          </v-btn>

          <!-- Édition V2 : déclenche la re-signature médecin via PATCH -->
          <template
            v-if="
              selectedItem &&
              !selectedItem.deletedAt &&
              selectedItem.wave === 'V2'
            "
          >
            <v-btn x-small color="#e2007a" dark @click="enterEditMode">
              <v-icon x-small left>mdi-pencil-outline</v-icon>
              Modifier
            </v-btn>
          </template>

          <!-- Mise en corbeille : V2 uniquement, BDC actif (pas déjà supprimé) -->
          <v-btn
            v-if="
              selectedItem &&
              !selectedItem.deletedAt &&
              selectedItem.wave !== 'V1'
            "
            x-small
            color="red"
            dark
            @click="showDeleteConfirmDialog = true"
          >
            <v-icon x-small left>mdi-delete-outline</v-icon>
            Supprimer
          </v-btn>

          <!-- Actions pilotes : indisponibles en mode corbeille -->
          <template v-if="selectedItem && !selectedItem.deletedAt">
            <v-btn
              v-if="!selectedItem.isPilot && selectedItem.state !== 'OFF'"
              x-small
              color="purple"
              dark
              @click="togglePilot(selectedItem, true)"
            >
              Marquer pilote
            </v-btn>
            <v-btn
              v-if="
                selectedItem.isPilot && selectedItem.pilotStatus !== 'VALIDATED'
              "
              x-small
              color="grey"
              dark
              @click="togglePilot(selectedItem, false)"
            >
              Retirer pilote
            </v-btn>
            <v-btn
              v-if="selectedItem.isPilot && selectedItem.pilotStatus === 'NONE'"
              x-small
              color="orange"
              dark
              @click="updatePilotStatus(selectedItem, 'SUBMITTED')"
            >
              Soumis ASP
            </v-btn>
            <v-btn
              v-if="
                selectedItem.isPilot && selectedItem.pilotStatus === 'SUBMITTED'
              "
              x-small
              color="green"
              dark
              @click="updatePilotStatus(selectedItem, 'VALIDATED')"
            >
              Valide ASP
            </v-btn>
            <v-btn
              v-if="
                selectedItem.isPilot && selectedItem.pilotStatus === 'SUBMITTED'
              "
              x-small
              color="red"
              dark
              @click="updatePilotStatus(selectedItem, 'REJECTED')"
            >
              Rejete ASP
            </v-btn>
            <v-btn
              x-small
              color="primary"
              dark
              @click="openResendEmailDialog(selectedItem)"
            >
              <v-icon x-small left>mdi-email-send-outline</v-icon>
              Re-envoyer email
            </v-btn>
          </template>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDetailDialog">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modale confirmation correction + re-signature -->
    <confirm-resign-modal
      :value="showConfirmResign"
      :bdc="selectedItem"
      :diff="pendingDiff"
      :resign-reason="pendingResignReason"
      :loading="patchLoading"
      @input="showConfirmResign = $event"
      @update:resign-reason="pendingResignReason = $event"
      @confirm="confirmPatch"
      @cancel="cancelPatch"
    />

    <!-- Dialog de mise en corbeille du BDC -->
    <v-dialog v-model="showDeleteConfirmDialog" persistent max-width="460">
      <v-card>
        <v-card-title class="headline" style="color: #d32f2f">
          <v-icon left color="red">mdi-trash-can-outline</v-icon>
          Placer le BDC en corbeille ?
        </v-card-title>
        <v-card-text style="font-size: 13px">
          Le bon de commande sera
          <strong>récupérable pendant {{ trashTtlDays }} jours</strong>
          depuis l'onglet Corbeille. Il sera ensuite supprimé définitivement
          (PDFs et données de suivi PS inclus).
          <div
            style="
              background: #f5f5f5;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
            "
          >
            <template v-if="selectedItem">
              N° Éditeur : <strong>{{ selectedItem.numeroEditeur }}</strong
              ><br />
              <template v-if="selectedItem.resident">
                Praticien :
                <strong
                  >{{ selectedItem.resident.prénom }}
                  {{ selectedItem.resident.nom }}</strong
                ><br />
                RPPS : {{ selectedItem.resident.RPPS }}<br />
              </template>
              <template v-if="selectedItem.msp">
                FINESS : {{ selectedItem.msp.FINESS }}<br />
              </template>
              Montant HT : <strong>{{ selectedItem.montantSegurHT }} €</strong
              ><br />
              État : <strong>{{ selectedItem.state }}</strong
              ><br />
              Wave : <strong>{{ selectedItem.wave }}</strong>
            </template>
          </div>
          Le médecin (résident) et la structure (MSP) ne sont pas supprimés : un
          nouveau BDC peut être créé pour ce praticien.
          <div
            class="mt-4"
            style="font-size: 12px; color: #555; margin-bottom: 6px"
          >
            Tapez <strong>SUPPRIMER</strong> en majuscules pour activer le
            bouton :
          </div>
          <v-text-field
            v-model="deleteConfirmText"
            placeholder="SUPPRIMER"
            dense
            outlined
            hide-détails
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelDeleteBDC">Annuler</v-btn>
          <v-btn
            :color="canConfirmDelete ? 'red' : 'grey lighten-1'"
            :dark="canConfirmDelete"
            :disabled="!canConfirmDelete"
            @click="confirmDeleteBDC"
          >
            <v-icon left small>mdi-trash-can-outline</v-icon>
            Envoyer en corbeille
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de vidage manuel de la corbeille (action opérateur) -->
    <v-dialog v-model="showEmptyTrashDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline" style="color: #d32f2f">
          <v-icon left color="red">mdi-delete-empty-outline</v-icon>
          Vider la corbeille ?
        </v-card-title>
        <v-card-text style="font-size: 13px">
          <strong>Action irréversible</strong> : tous les BDC en corbeille
          seront immédiatement supprimés définitivement (PDFs, données de suivi
          PS et BDC).
          <div
            style="
              background: #ffebee;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
              color: #c62828;
            "
          >
            <v-icon small color="red darken-2" left>mdi-alert-outline</v-icon>
            <strong>{{ tabCounts.deleted || 0 }}</strong> BDC seront purgés.
          </div>
          <div
            class="mt-4"
            style="font-size: 12px; color: #555; margin-bottom: 6px"
          >
            Tapez <strong>VIDER</strong> en majuscules pour activer le bouton :
          </div>
          <v-text-field
            v-model="emptyTrashConfirmText"
            placeholder="VIDER"
            dense
            outlined
            hide-détails
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelEmptyTrash">Annuler</v-btn>
          <v-btn
            :color="canConfirmEmptyTrash ? 'red' : 'grey lighten-1'"
            :dark="canConfirmEmptyTrash"
            :disabled="!canConfirmEmptyTrash"
            @click="confirmEmptyTrash"
          >
            <v-icon left small>mdi-delete-forever</v-icon>
            Vider définitivement
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de conflit a la restauration : un BDC actif existe déjà (RPPS / FINESS) -->
    <v-dialog
      :value="!!restoreConflict"
      persistent
      max-width="500"
      @input="cancelRestoreSwap"
    >
      <v-card v-if="restoreConflict">
        <v-card-title class="headline" style="color: #f57c00">
          <v-icon left color="orange darken-2">mdi-swap-horizontal</v-icon>
          Conflit de restauration
        </v-card-title>
        <v-card-text style="font-size: 13px">
          Un BDC actif existe déjà pour ce
          <strong v-if="restoreConflict.type === 'STRUCTURE'"
            >établissement</strong
          >
          <strong v-else>praticien</strong>.
          <div
            style="
              background: #fff3e0;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
            "
          >
            <strong>BDC actif concurrent</strong><br />
            N° Éditeur : <strong>{{ restoreConflict.numeroEditeur }}</strong
            ><br />
            <template v-if="restoreConflict.RPPS">
              Praticien :
              <strong
                >{{ restoreConflict.prénom }} {{ restoreConflict.nom }}</strong
              ><br />
              RPPS : {{ restoreConflict.RPPS }}<br />
            </template>
            <template v-if="restoreConflict.FINESS">
              FINESS : {{ restoreConflict.FINESS }}<br />
            </template>
            État : {{ restoreConflict.state }}
          </div>
          <strong>Échanger</strong> : envoie le BDC actif ci-dessus en corbeille
          puis restaure le BDC sélectionné. Action transactionnelle, tracée dans
          l'audit.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelRestoreSwap">Annuler</v-btn>
          <v-btn color="orange darken-2" dark @click="confirmRestoreSwap">
            <v-icon left small>mdi-swap-horizontal</v-icon>
            Échanger
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de re-envoi du BDC sur une adresse email alternative -->
    <v-dialog v-model="showResendEmailDialog" max-width="460">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="primary">mdi-email-send-outline</v-icon>
          Re-envoyer le bon de commande
        </v-card-title>
        <v-card-text style="font-size: 13px">
          Le BDC sera renvoyé à l'adresse saisie ci-dessous. Le statut d'envoi
          sera mis à jour.
          <div
            v-if="selectedItem"
            style="
              background: #f5f5f5;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
            "
          >
            N° Éditeur : <strong>{{ selectedItem.numeroEditeur }}</strong
            ><br />
            <template v-if="selectedItem.resident">
              Praticien :
              <strong
                >{{ selectedItem.resident.prénom }}
                {{ selectedItem.resident.nom }}</strong
              ><br />
              Email enregistré : {{ selectedItem.resident.email || "-" }}
            </template>
          </div>
          <v-text-field
            v-model="resendEmailInput"
            label="Adresse email destinataire"
            type="email"
            placeholder="exemple@domaine.fr"
            outlined
            dense
            autofocus
            :disabled="resendEmailLoading"
          ></v-text-field>
          <v-checkbox
            v-model="resendEmailUpdateResident"
            label="Sauvegarder cette adresse en base (remplace l'email du résident pour tous ses BDC)"
            :disabled="resendEmailLoading || !canUpdateResidentEmail"
            hide-details
            dense
          ></v-checkbox>
          <div
            v-if="resendEmailFeedback"
            :style="{
              color: resendEmailFeedback.success ? 'green' : 'red',
              fontSize: '12px',
            }"
          >
            {{ resendEmailFeedback.message }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            :disabled="resendEmailLoading"
            @click="closeResendEmailDialog"
            >Annuler</v-btn
          >
          <v-btn
            color="primary"
            :loading="resendEmailLoading"
            :disabled="!isValidResendEmail || resendEmailLoading"
            @click="confirmResendEmail"
          >
            <v-icon left small>mdi-send</v-icon>
            Envoyer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import server from "@/store/server";
import EditableBdcCard from "@/components/Segur/EditableBdcCard.vue";
import ConfirmResignModal from "@/components/Segur/ConfirmResignModal.vue";

const API_BASE = server.url;
const PAGE_SIZE = 50;

export default {
  name: "SegurV2",
  components: {
    EditableBdcCard,
    ConfirmResignModal,
  },
  data() {
    return {
      stats: null,
      apiBase: API_BASE,
      rows: [],
      psRows: [],
      totalCount: 0,
      tabCounts: {},
      currentTab: "all",
      query: "",
      sortBy: "N° Éditeur",
      sortOrder: "Décroissant",
      sortOptions: ["N° Éditeur", "N° ASP", "Montant", "Date", "État"],
      emailStatusFilter: "Tous",
      emailStatusFilterOptions: [
        "Tous",
        "Envoyé",
        "Échec",
        "En cours",
        "Non suivi",
      ],
      partyType: "all",
      partyTypeOptions: [
        { text: "Tous", value: "all" },
        { text: "MSP uniquement", value: "msp" },
        { text: "Libéral uniquement", value: "liberal" },
      ],
      searchTruncated: false,
      page: 1,
      dialog: false,
      selectedItem: null,
      showDeleteConfirmDialog: false,
      deleteConfirmText: "",
      showResendEmailDialog: false,
      resendEmailInput: "",
      resendEmailLoading: false,
      resendEmailFeedback: null,
      resendEmailUpdateResident: false,
      // Corbeille SEGUR V2
      trashTtlDays: 30, // Surcharge par /segur/v2/orderforms (top-level)
      showEmptyTrashDialog: false,
      emptyTrashConfirmText: "",
      restoreConflict: null, // { id, numeroEditeur, RPPS, FINESS, type } recu en 409
      restoreConflictFor: null, // BDC qu'on essaie de restaurer (pour reprendre l'échange)

      editMode: false,
      pendingDiff: {},
      pendingResignReason: "",
      showConfirmResign: false,
      patchLoading: false,
    };
  },
  computed: {
    // Garde-fou UI : le bouton "Envoyer en corbeille" reste grisé tant que
    // l'opérateur n'a pas tapé "SUPPRIMER" en majuscules dans le champ de confirmation.
    canConfirmDelete() {
      return this.deleteConfirmText === "SUPPRIMER";
    },
    // Garde-fou UI corbeille : bouton "Vider" grisé tant que VIDER n'est pas tapé
    canConfirmEmptyTrash() {
      return this.emptyTrashConfirmText === "VIDER";
    },
    isTrashTab() {
      return this.currentTab === "deleted";
    },
    // Validation legere de l'email (même regex que côté serveur)
    isValidResendEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.resendEmailInput || "");
    },
    // Checkbox "Sauvegarder en base" desactivee si email invalide ou identique a
    // celui deja stocke sur le resident : evite de proposer un update no-op.
    canUpdateResidentEmail() {
      if (!this.isValidResendEmail) return false;
      const current = (this.selectedItem?.resident?.email || "")
        .trim()
        .toLowerCase();
      const next = (this.resendEmailInput || "").trim().toLowerCase();
      return current !== next;
    },
    tabDefs() {
      return [
        { key: "all", label: "Tous" },
        { key: "enCours", label: "En cours" },
        { key: "soumisAsp", label: "Soumis ASP" },
        { key: "rejetes", label: "Rejetés" },
        { key: "va", label: "VA" },
        { key: "pilots", label: "Pilotes" },
        { key: "mustResign", label: "À re-signer" },
        { key: "ps", label: "Prest. Secondaire" },
        { key: "deleted", label: "Corbeille" },
      ];
    },
    pageCount() {
      return Math.ceil(this.totalCount / PAGE_SIZE) || 1;
    },
  },
  watch: {
    currentTab() {
      this.page = 1;
      if (this.currentTab === "ps") {
        this.fetchPS();
      } else {
        this.fetchOrderForms();
      }
    },
    page() {
      this.fetchOrderForms();
    },
  },
  async created() {
    await Promise.all([this.fetchStats(), this.fetchOrderForms()]);
  },
  methods: {
    async fetchStats() {
      try {
        const res = await axios.get(`${API_BASE}/segur/v2/stats`, {
          headers: server.getHeader(),
        });
        if (res.data && res.data.success) {
          this.stats = res.data.data;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[Segur] Erreur stats:", err.message);
      }
    },

    async fetchOrderForms() {
      try {
        const sortMap = {
          "N° Éditeur": "numeroEditeur",
          "N° ASP": "numeroASP",
          Montant: "montant",
          Date: "date",
          État: "state",
        };
        // Mapping label UI -> valeur API. "Tous" = pas de filtre (envoie null).
        const emailStatusMap = {
          Tous: null,
          Envoyé: "SENT",
          Échec: "FAILED",
          "En cours": "PENDING",
          "Non suivi": "NONE",
        };
        // Onglet "À re-signer" : on omet sortBy quand l'admin garde le défaut
        // pour laisser le serveur trier par resignMarkedAt DESC (la condition
        // côté backend est `req.body.sortBy === undefined`).
        const sortByDefault = this.sortBy === "N° Éditeur";
        const sortByMapped = this.currentTab === "mustResign" && sortByDefault
          ? undefined
          : (sortMap[this.sortBy] || "numeroEditeur");
        const res = await axios.post(
          `${API_BASE}/segur/v2/orderforms`,
          {
            tab: this.currentTab,
            search: this.query,
            sortBy: sortByMapped,
            sortOrder: this.sortOrder === "Croissant" ? "ASC" : "DESC",
            offset: (this.page - 1) * PAGE_SIZE,
            limit: PAGE_SIZE,
            emailStatus: emailStatusMap[this.emailStatusFilter] || null,
            partyType: this.partyType,
          },
          { headers: server.getHeader() }
        );
        if (res.data && res.data.success) {
          this.rows = res.data.data.rows;
          this.totalCount = res.data.data.count;
          this.tabCounts = res.data.data.tabs;
          this.searchTruncated = !!res.data.data.searchTruncated;
          // TTL corbeille expose au top level par le backend (env TRASH_TTL_DAYS, default 30)
          if (typeof res.data.data.trashTtlDays === "number") {
            this.trashTtlDays = res.data.data.trashTtlDays;
          }
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[Segur] Erreur listing:", err.message);
      }
    },

    async fetchPS() {
      try {
        // L'onglet PS n'a pas de recherche : reset le warning sinon il reste
        // visible avec un état hérité d'un onglet BDC précédent.
        this.searchTruncated = false;
        const res = await axios.get(
          `${API_BASE}/segur/v2/prestations-secondaires`,
          { headers: server.getHeader() }
        );
        if (res.data && res.data.success) {
          this.psRows = res.data.data;
          this.tabCounts = { ...this.tabCounts, ps: res.data.data.length };
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[Segur] Erreur PS:", err.message);
      }
    },

    async downloadPdf(type, id) {
      try {
        // Onglet Corbeille : header explicite pour autoriser le download d'un PDF
        // dont le parent est en corbeille (sinon le backend renvoie 404).
        const headers = { ...server.getHeader() };
        if (this.currentTab === "deleted") {
          headers["X-Trash-Context"] = "true";
        }
        const res = await axios.get(
          `${API_BASE}/segur/download/${type}/${id}`,
          { headers, responseType: "blob" }
        );
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${type}-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[Segur] Erreur téléchargement PDF:", err.message);
      }
    },

    search() {
      this.page = 1;
      this.fetchOrderForms();
    },

    clearSearch() {
      this.query = "";
      this.emailStatusFilter = "Tous";
      this.partyType = "all";
      this.page = 1;
      this.fetchOrderForms();
    },

    mspTooltip(msp) {
      if (!msp) return "";
      const parts = [];
      if (msp.FINESSGEO) parts.push("FINESS GEO : " + msp.FINESSGEO);
      if (msp.raisonSociale) parts.push(msp.raisonSociale);
      return parts.join(" - ");
    },

    openDetail(item) {
      this.selectedItem = item;
      this.dialog = true;
    },

    getDate(d) {
      if (!d) return "";
      const date = new Date(d);
      return (
        ("0" + date.getDate()).slice(-2) +
        "/" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        date.getFullYear()
      );
    },

    stateLabel(state) {
      if (state === "ON") return "Terminé";
      if (state === "ENABLE") return "Signé";
      if (state === "OFF") return "Non signé";
      if (state === "DISABLE") return "Désactivé";
      return state;
    },

    stateColor(state) {
      if (state === "ON") return "green";
      if (state === "ENABLE") return "orange";
      if (state === "DISABLE") return "grey";
      return "red";
    },

    typeColor(type) {
      if (type === "V2") return "blue";
      if (type === "V1V2") return "orange";
      return "grey";
    },

    psColor(status) {
      if (status === "APPROVED") return "green";
      if (status === "READY") return "blue";
      if (status === "MONITORING") return "orange";
      if (status === "REJECTED") return "red";
      return "grey";
    },

    pilotColor(status) {
      if (status === "VALIDATED") return "green";
      if (status === "SUBMITTED") return "orange";
      if (status === "REJECTED") return "red";
      return "purple";
    },

    pilotLabel(status) {
      if (status === "VALIDATED") return "Validé";
      if (status === "SUBMITTED") return "Soumis";
      if (status === "REJECTED") return "Rejeté";
      return "Pilote";
    },

    // Statut email BDC : SENT/FAILED/PENDING/null (BDC pre-migration)
    emailStatusColor(status) {
      if (status === "SENT") return "green";
      if (status === "FAILED") return "red";
      if (status === "PENDING") return "grey";
      return "grey lighten-1";
    },

    emailStatusLabel(status) {
      if (status === "SENT") return "Envoyé";
      if (status === "FAILED") return "Échec";
      if (status === "PENDING") return "Envoi en cours";
      return "Non suivi";
    },

    openResendEmailDialog(item) {
      // Pre-remplit avec l'email du resident (déjà dans le payload listing V2)
      this.resendEmailInput = item?.resident?.email || "";
      this.resendEmailFeedback = null;
      this.resendEmailUpdateResident = false;
      this.showResendEmailDialog = true;
    },

    closeResendEmailDialog() {
      this.showResendEmailDialog = false;
      this.resendEmailInput = "";
      this.resendEmailFeedback = null;
      this.resendEmailUpdateResident = false;
    },

    async confirmResendEmail() {
      if (!this.selectedItem || !this.isValidResendEmail) return;
      this.resendEmailLoading = true;
      this.resendEmailFeedback = null;
      // Snapshot du flag combine avec canUpdateResidentEmail : si la checkbox est
      // restee cochee mais que l'email a ete remis a celui du resident, on n'envoie
      // pas updateResidentEmail=true (la checkbox est desactivee mais le model garde
      // sa valeur).
      const wantedUpdate =
        this.resendEmailUpdateResident && this.canUpdateResidentEmail;
      try {
        const response = await axios.post(
          `${this.apiBase}/segur/v2/orderforms/${this.selectedItem.id}/resend-email`,
          { email: this.resendEmailInput, updateResidentEmail: wantedUpdate },
          { headers: server.getHeader() }
        );
        // Response.success(res, data) => { success: true, data: {...} }
        const payload = response.data?.data || {};
        const updated = payload.residentEmailUpdated === true;
        const updateError = payload.residentUpdateError || null;
        // emailSentTo vient du backend deja trime ; fallback sur le saisi trime
        const sentTo =
          payload.emailSentTo || (this.resendEmailInput || "").trim();

        // Met a jour le selectedItem en local pour rafraichir le badge sans reload
        if (this.selectedItem) {
          this.selectedItem.emailStatus = "SENT";
          this.selectedItem.emailError = null;
          if (updated && this.selectedItem.resident) {
            this.selectedItem.resident.email = sentTo;
          }
        }

        let message = `Email envoyé avec succès à ${sentTo}.`;
        if (wantedUpdate) {
          if (updated) {
            message += " Adresse du résident mise à jour en base.";
          } else if (updateError) {
            message += ` Attention : adresse non mise à jour en base (${updateError}).`;
          }
          // Sinon : flag coche mais updated=false sans error => no-op
          // (adresse identique apres normalisation), pas de mention necessaire.
        }
        this.resendEmailFeedback = { success: true, message };

        // Refresh listing pour synchroniser les autres lignes/onglets
        await this.fetchOrderForms();
        // Ferme après un petit délai pour laisser voir le message de succes
        setTimeout(() => this.closeResendEmailDialog(), 1200);
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        this.resendEmailFeedback = {
          success: false,
          message: `Échec : ${msg}`,
        };
        // Le backend a déjà persiste emailStatus = FAILED avant le 502 :
        // refletter ca dans l'UI pour que le badge ne reste pas obsolete jusqu'au
        // prochain refresh manuel.
        if (this.selectedItem) {
          this.selectedItem.emailStatus = "FAILED";
          this.selectedItem.emailError = msg;
        }
        await this.fetchOrderForms();
      } finally {
        this.resendEmailLoading = false;
      }
    },

    async togglePilot(item, isPilot) {
      try {
        await axios.patch(
          `${this.apiBase}/segur/v2/orderforms/${item.id}/pilot`,
          { isPilot },
          { headers: server.getHeader() }
        );
        this.dialog = false;
        this.fetchOrderForms();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(msg);
      }
    },

    async updatePilotStatus(item, pilotStatus) {
      try {
        await axios.patch(
          `${this.apiBase}/segur/v2/orderforms/${item.id}/pilot-status`,
          { pilotStatus },
          { headers: server.getHeader() }
        );
        this.dialog = false;
        this.fetchOrderForms();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(msg);
      }
    },

    // Annulation du dialog de suppression : reset du champ de confirmation
    cancelDeleteBDC() {
      this.showDeleteConfirmDialog = false;
      this.deleteConfirmText = "";
    },

    // Mise en corbeille du BDC (récupérable pendant trashTtlDays jours)
    // Garde-fou UI : l'opérateur doit taper "SUPPRIMER" pour dégriser le bouton
    async confirmDeleteBDC() {
      if (!this.selectedItem) return;
      if (this.deleteConfirmText !== "SUPPRIMER") return;
      try {
        await axios.delete(
          `${this.apiBase}/segur/v2/orderforms/${this.selectedItem.id}`,
          { headers: server.getHeader() }
        );
        this.showDeleteConfirmDialog = false;
        this.deleteConfirmText = "";
        this.dialog = false;
        this.selectedItem = null;
        await this.fetchOrderForms();
        await this.fetchStats();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(`Erreur lors de la mise en corbeille : ${msg}`);
      }
    },

    // --- Corbeille SEGUR V2 -----------------------------------------------

    // Couleur du badge "Purge dans X j" selon proximite TTL
    purgeColor(purgeScheduledAt) {
      if (!purgeScheduledAt) return "grey";
      const days = Math.ceil(
        (new Date(purgeScheduledAt).getTime() - Date.now()) / 86400000
      );
      if (days <= 0) return "red darken-2";
      if (days <= 7) return "red";
      if (days <= 14) return "orange";
      return "grey";
    },

    purgeLabel(purgeScheduledAt) {
      if (!purgeScheduledAt) return "";
      const days = Math.ceil(
        (new Date(purgeScheduledAt).getTime() - Date.now()) / 86400000
      );
      if (days <= 0) return "Purge imminente";
      if (days === 1) return "Purge dans 1 j";
      return `Purge dans ${days} j`;
    },

    async restoreBDC(item) {
      if (!item) return;
      try {
        await axios.post(
          `${this.apiBase}/segur/v2/orderforms/${item.id}/restore`,
          {},
          { headers: server.getHeader() }
        );
        this.dialog = false;
        this.selectedItem = null;
        await this.fetchOrderForms();
        await this.fetchStats();
      } catch (err) {
        // 409 RESTORE_CONFLICT : le backend a détecté un BDC actif concurrent
        if (
          err.response?.status === 409 &&
          err.response?.data?.errorCode === "RESTORE_CONFLICT"
        ) {
          this.restoreConflict = err.response.data.conflictWith;
          this.restoreConflictFor = item;
          return;
        }
        // 410 Gone : TTL expirée
        if (err.response?.status === 410) {
          alert(
            "Ce BDC ne peut plus être restaure (délai expirée). Il sera purge définitivement par le cron."
          );
          await this.fetchOrderForms();
          return;
        }
        const msg = err.response?.data?.error || err.message;
        alert(`Erreur lors de la restauration : ${msg}`);
      }
    },

    async confirmRestoreSwap() {
      if (!this.restoreConflictFor || !this.restoreConflict) return;
      try {
        await axios.post(
          `${this.apiBase}/segur/v2/orderforms/${this.restoreConflictFor.id}/restore-swap`,
          { swapWithId: this.restoreConflict.id },
          { headers: server.getHeader() }
        );
        this.restoreConflict = null;
        this.restoreConflictFor = null;
        this.dialog = false;
        this.selectedItem = null;
        await this.fetchOrderForms();
        await this.fetchStats();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(`Échange impossible : ${msg}`);
      }
    },

    cancelRestoreSwap() {
      this.restoreConflict = null;
      this.restoreConflictFor = null;
    },

    openEmptyTrashDialog() {
      this.emptyTrashConfirmText = "";
      this.showEmptyTrashDialog = true;
    },

    cancelEmptyTrash() {
      this.showEmptyTrashDialog = false;
      this.emptyTrashConfirmText = "";
    },

    async confirmEmptyTrash() {
      if (this.emptyTrashConfirmText !== "VIDER") return;
      try {
        await axios.post(
          `${this.apiBase}/segur/v2/orderforms/trash/empty`,
          { confirm: "VIDER" },
          { headers: server.getHeader() }
        );
        this.showEmptyTrashDialog = false;
        this.emptyTrashConfirmText = "";
        await this.fetchOrderForms();
        await this.fetchStats();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(`Erreur lors du vidage de la corbeille : ${msg}`);
      }
    },

    enterEditMode() {
      this.editMode = true;
    },

    cancelEditMode() {
      this.editMode = false;
      this.pendingDiff = {};
      this.pendingResignReason = "";
    },

    closeDetailDialog() {
      if (this.editMode) {
        const confirmed = window.confirm(
          "Édition en cours. Fermer abandonne les modifications. Continuer ?"
        );
        if (!confirmed) return;
      }
      this.editMode = false;
      this.pendingDiff = {};
      this.pendingResignReason = "";
      this.dialog = false;
    },

    onDialogToggle(open) {
      if (!open) {
        this.editMode = false;
        this.pendingDiff = {};
        this.pendingResignReason = "";
      }
    },

    onEditableSave(diff) {
      if (!diff || Object.keys(diff).length === 0) return;
      this.pendingDiff = diff;
      // Reset systématique du motif à chaque ouverture pour éviter de réutiliser
      // un motif d'un précédent PATCH.
      this.pendingResignReason = "";
      this.showConfirmResign = true;
    },

    cancelPatch() {
      this.showConfirmResign = false;
      this.pendingResignReason = "";
    },

    async confirmPatch() {
      if (!this.selectedItem || !this.pendingDiff || this.patchLoading) return;
      this.patchLoading = true;
      try {
        // Le motif est toujours envoyé (même vide) pour écraser l'éventuel
        // motif persisté lors d'un PATCH précédent.
        const payload = {
          ...this.pendingDiff,
          resignReason: (this.pendingResignReason || "").trim(),
        };
        const res = await axios.patch(
          `${this.apiBase}/segur/v2/orderforms/${this.selectedItem.id}`,
          payload,
          { headers: server.getHeader() }
        );
        const result = res.data?.data || {};
        const updated = Array.isArray(result.updated) ? result.updated : [];
        const tablesMsg = updated.length > 0 ? ` (${updated.join(", ")})` : "";
        this.$toast
          ? this.$toast(`BDC mis à jour${tablesMsg}. Le médecin sera notifié.`)
          : alert(`BDC mis à jour${tablesMsg}. Le médecin sera notifié.`);
        this.showConfirmResign = false;
        this.pendingDiff = {};
        this.pendingResignReason = "";
        this.editMode = false;
        this.dialog = false;
        this.selectedItem = null;
        await this.fetchOrderForms();
        await this.fetchStats();
      } catch (err) {
        const status = err.response?.status;
        const data = err.response?.data;
        if (status === 400 && data?.data?.details) {
          const lines = data.data.details
            .map((d) => `- ${d.path} : ${d.message}`)
            .join("\n");
          alert(`Payload invalide :\n${lines}`);
        } else if (status === 404) {
          alert("BDC introuvable");
        } else if (status === 400) {
          alert(data?.error || data?.data?.error || "Requête invalide");
        } else {
          alert(`Erreur : ${data?.error || err.message}`);
        }
      } finally {
        this.patchLoading = false;
      }
    },

  },
};
</script>

<style scoped>
.content {
  max-width: 100%;
  padding: 0;
}

/* Tous les blocs alignes sur la même largeur */
.content > .v-card,
.content > .md-card,
.content > .v-tabs,
.content > .v-tabs-items {
  margin-left: 0;
  margin-right: 0;
}

/* Tableau pleine largeur */
.md-table {
  width: 100%;
}

.md-table .md-table-cell {
  white-space: nowrap;
  font-size: 13px;
  padding: 4px 8px;
}

/* Chips plus compacts */
.v-chip.v-size--x-small {
  font-size: 11px;
  height: 20px;
}

/* Tabs filtres : texte blanc, actif en blanc gras (pas de bleu) */
.v-tabs .v-tab {
  color: rgba(255, 255, 255, 0.7) !important;
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: 0.5px;
}
.v-tabs .v-tab--active {
  color: #fff !important;
  font-weight: bold;
}
</style>
